// extracted by mini-css-extract-plugin
export default {"cls1":"AboutTheAuthorsSection-cls1_XSh","cls2":"AboutTheAuthorsSection-cls2_x7u AboutTheAuthorsSection-cls1_XSh"};